const shape = {
  borderRadius: 60,
  borderRadiusMobileNav: 35,
  borderRadiusSwitch: 15,
  borderRadiusThemeSwitch: 40,
  borderRadiusGeneral: 30,
};

export default shape;
